module.exports = __webpack_public_path__ + "img/feature_buy_en.a02914af.png";